import { getUploadSignedUrl } from "@/store/actions"
import FetchFileService from "./FetchFileService"
import { fileConverter } from "./fileConverter"
import { cdn_url } from "./path"

export const complementaryUpload = async (
  dispatch: any,
  files: any, // Each file here will be an object with { file: File, isFeatured: boolean }
  story: any,
  isVideo: boolean = false,
  isImage: boolean = false
) => {
  return new Promise(async (resolve, reject) => {
    const data: any = [];
    let timestamp = Date.now(); 

    for (const mediaItem of files) {
      const file = mediaItem?.file;
      const isFeatured = mediaItem?.isFeatured || false;

      if (file?.name?.includes('stories/') || file?.name?.includes('videos/') || typeof file === "object" && file?.url) {

        data.push({
          fileName: file?.url ? file.url.replace("https://cdn.memvy.com/", "") : file.name,
          isFeatured: isFeatured
        });

        if (data.length === files.length) {
          resolve(data);
        }
        continue;
      }

      const originalName = file?.name?.split('/')?.pop()?.replace(/\.[^.]+$/, '');
      const extension = file?.name?.match(/\.[^.]+$/)?.[0] || '';
      const safeTitle = story?.title || 'untitled';
      const fileName = isVideo
        ? `videos/${story?.title}/memories/${timestamp}_${originalName}${extension}`
        : isImage
          ? `stories/${safeTitle}/memories/${timestamp}_${originalName}.webp`
          : `stories/${safeTitle}/memories/${timestamp}_${originalName}${extension}`;

      dispatch(
        getUploadSignedUrl(
          { file: fileName, type: isImage ? 'image/webp' : file?.type },
          async (res: any) => {
            let response: any = null;

            try {
              if (isImage) {
                const newFile = await fileConverter(file);
                response = await FetchFileService(res?.value?.url?.uploadUrl, 'PUT', newFile, 'image/webp');
              } else if (isVideo) {
                response = await FetchFileService(res?.value?.url?.uploadUrl, 'PUT', file, 'video/mp4');
              }
              else {
                response = await FetchFileService(res?.value?.url?.uploadUrl, 'PUT', file, file?.type);

              }


              if (response?.ok) {
                data.push({
                  fileName,
                  isFeatured: isFeatured
                });
              }

              if (data.length === files.length) {
                resolve(data);
              }
            } catch (error) {
              console.error('Error uploading file:', error);
              reject(error);
            }
          }
        )
      );
      timestamp += 1000;
    }
  });
};






export const complementaryDownload = async (dispatch: any, files: any) => {
  // console.log("md-file-download", files);

  return new Promise((resolve, reject) => {
    try {
      // console.log("files got in com download are", files)
      const data: any = [];

      // Ensure files is always an array
      const filesArray = Array.isArray(files) ? files : [files];

      for (const file of filesArray) {
        const filePath =
          typeof file === "object" && file?.fileName
            ? file.fileName
            : typeof file === "string"
              ? file
              : null;

        if (!filePath) continue; // Skip invalid files

        // Construct the CDN URL
        const fullUrl = `${cdn_url}${filePath}`;

        const featured = typeof file === "object" && file?.isFeatured
          ? file.isFeatured :
          file?.isFeatured


        // Push the URL and use it as a preview
        data.push({ url: fullUrl, preview: fullUrl, isFeatured: featured });
      }
      // console.log("data files", data)
      resolve(data);
    } catch (error) {
      console.error("Error processing files:", error);
      reject(error);
    }
  });
};
